import loadable from '@loadable/component';

export const OrgDashboardApiAccessPageLoadable = loadable(
  () => import('./OrgDashboardApiAccessPage'),
  {
    resolveComponent: (module) => module.OrgDashboardApiAccessPage,
  },
);
